/* eslint-disable react/jsx-max-props-per-line */
import FacebookIcon from '@root/brand/src/components/icons/facebook-icon';
import FooterBase from '@root/brand/src/components/footer-base';
import FooterDisclaimer from '@root/brand/src/components/footer-disclaimer';
import IconLink from '@root/brand/src/components/icons/icon-link';
import InstagramIcon from '@root/brand/src/components/icons/instagram-icon';
import Link from '@root/gatsby-contentful-core/src/components/smart-link';
import LinkedinIcon from '@root/brand/src/components/icons/linkedin-icon';
import React from '@root/vendor/react';
import Responsive from '@root/core/src/utils/responsive';
import RootLogo from '@root/brand/src/components/root-logo';
import Theme from '@root/gatsby-contentful-core/src/components/brand/theme';
import TwitterIcon from '@root/brand/src/components/icons/twitter-icon';
import YouTubeIcon from '@root/brand/src/components/icons/youtube-icon';
import { Colors, StyleSheet } from '@root/core/src/utils/styles';

export default function PartnershipsFooter() {
  return (
    <FooterBase>
      <a href={'/'}>
        <RootLogo logoStyles={styles.logo} />
      </a>
      <div css={styles.iconsContainer}>
        <IconLink
          linkStyles={styles.iconLink}
          to={'https://www.facebook.com/rootinsurance/'}
        >
          <FacebookIcon iconStyles={styles.iconSvg} />
        </IconLink>
        <IconLink
          linkStyles={styles.iconLink}
          to={'https://www.instagram.com/rootinsurance/'}
        >
          <InstagramIcon iconStyles={styles.iconSvg} />
        </IconLink>
        <IconLink
          linkStyles={styles.iconLink}
          to={'https://twitter.com/rootinsurance/'}
        >
          <TwitterIcon iconStyles={styles.iconSvg} />
        </IconLink>
        <IconLink
          linkStyles={styles.iconLink}
          to={'https://linkedin.com/company/rootinsurance/'}
        >
          <LinkedinIcon iconStyles={styles.iconSvg} />
        </IconLink>
        <IconLink
          linkStyles={styles.iconLink}
          to={'https://www.youtube.com/c/RootInsurance'}
        >
          <YouTubeIcon iconStyles={[styles.iconSvg, styles.ytIconSvg]} />
        </IconLink>
      </div>
      <div css={styles.linksAndAddressContainer}>
        <div css={styles.linksContainer}>
          <div css={styles.column}>
            <Link css={styles.link} to={'/claims'}>Claims</Link>
            <Link css={styles.link} to={'/contact'}>Contact</Link>
            <Link css={styles.link} to={'https://ir.joinroot.com/'}>Investor relations</Link>
            <Link css={styles.link} to={'/terms-and-conditions'}>Terms and conditions</Link>
          </div>
          <div css={styles.column}>
            <Link css={styles.link} to={'/consumer-privacy-notice'}>Consumer Privacy Notice</Link>
            <Link css={styles.link} to={'/car-insurance/telematics'}>Telematics</Link>
            <Link css={styles.link} to={'/privacy-policy'}>Privacy policy</Link>
          </div>
          <div css={styles.column}>
            <Link css={styles.link} to={'/app-eula'}>App license agreement</Link>
            <Link css={styles.link} to={'/privacy/data-collection/'}>Do not sell or share my personal information</Link>
            <ManageCookiesLink />
          </div>
        </div>
        <div css={styles.address}>
          <p css={styles.addressLine}>Root Inc.</p>
          <p css={styles.addressLine}>80 E. Rich Street</p>
          <p css={styles.addressLine}>Suite 500</p>
          <p css={styles.addressLine}>Columbus, OH 43215</p>
        </div>
      </div>
      <FooterDisclaimer
        containerStyles={styles.footerDisclaimer}
        onlyShowCopyright={false}
      />
    </FooterBase>
  );
}

function ManageCookiesLink() {
  const toggleOsanoSidebar = () => {
    if (window.Osano.cm.drawerOpen) {
      window.Osano.cm.hideDrawer('osano-cm-dom-info-dialog-open');
    } else {
      window.Osano.cm.showDrawer('osano-cm-dom-info-dialog-open');
    }
  };

  return (
    <a
      css={styles.link}
      onClick={toggleOsanoSidebar}
    >
      Manage Cookies
    </a>
  );
}

const styles = StyleSheet.create({
  logo: {
    display: 'block',
    marginBottom: 40,
    width: 205,
    height: 'auto',
  },
  iconsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    maxWidth: 320,
    marginBottom: 40,
  },
  iconLink: {
    height: 30,
    '&:last-of-type': {
      marginRight: 0,
    },
    '&:hover svg': {
      fill: Colors.rootOrange(),
    },
    '&:focus svg': {
      fill: Colors.rootOrange(),
    },
  },
  iconSvg: {
    fill: '#c4c4c4',
    transition: 'fill 150ms cubic-bezier(0.455, 0.03, 0.515, 0.955);',
    width: 26,
  },
  ytIconSvg: {
    width: 30,
  },
  linksAndAddressContainer: {
    marginBottom: 30,
    ...Responsive.md({
      display: 'flex',
      justifyContent: 'space-between',
    }),
  },
  linksContainer: {
    marginBottom: 30,
    ...Responsive.md({
      display: 'flex',
      flexDirection: 'row',
      flexGrow: 2,
    }),
  },
  column: {
    marginBottom: 30,
    ...Responsive.md({
      flexGrow: 1,
      marginBottom: 0,
    }),
  },
  link: {
    ...Theme.bodyRegular(),
    display: 'block',
    transition: 'color 150ms cubic-bezier(0.455, 0.03, 0.515, 0.955);',
    lineHeight: '29px',
    textDecoration: 'none',
    color: Colors.rootOrange(),
    cursor: 'pointer',
    ':hover': {
      color: Colors.black(),
    },
    ':focus': {
      color: Colors.black(),
    },
    ...Responsive.md({
      fontSize: 15,
    }),
  },
  address: {
    marginBottom: 30,
  },
  addressLine: {
    ...Theme.bodyRegular(),
    lineHeight: '29px',
    marginBottom: 0,
    ...Responsive.md({
      ...Theme.bodySmall(),
      lineHeight: '29px',
    }),
  },
  footerDisclaimer: {
    ...Theme.bodyTiny(),
  },
});
